export default "__VITE_ASSET__DT1MN6vr__"